// WEB.CL3 (11 Oct 2026, DT.269) -- los enlaces de SOPORTE del panel van al correo de soporte.
//
// Antes abrian WhatsApp con el numero COMERCIAL de platform, que lo contesta el asistente
// comercial y no una persona (decision de Jesus, 11 Oct 2026). Los de VENTAS («Hablar con
// ventas», «¿Quieres este plan?», la landing) se quedan en el comercial (decision 6A).
//
// 🔴 El correo NO se escribe aqui (regla de TEN.4): llega de `GET /api/publico/alta`
//    (`contacto_email`, constante `CONTACTO_EMAIL` del backend) por `useDatosAlta()`. Si no
//    llega, esta funcion devuelve null y quien la usa NO pinta el enlace (nunca un respaldo).
export function enlaceSoporte(correo, cuerpo) {
  if (!correo) return null;
  return `mailto:${correo}` + (cuerpo ? `?body=${encodeURIComponent(cuerpo)}` : "");
}
